import type { ReactNode } from 'react';
import { cx } from './cx';

type PillTone = 'neutral' | 'accent' | 'success' | 'danger';

const TONE_CLASS: Record<PillTone, string> = {
  neutral: 'bg-surface-raised text-ink-muted',
  accent: 'bg-accent-soft text-accent',
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger',
};

export function StatusPill({
  tone = 'neutral',
  dot = false,
  pulse = false,
  children,
}: {
  tone?: PillTone;
  dot?: boolean;
  pulse?: boolean;
  children: ReactNode;
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        TONE_CLASS[tone],
      )}
    >
      {dot ? (
        <span
          className={cx('h-1.5 w-1.5 rounded-full bg-current', pulse && 'animate-pulse')}
          aria-hidden="true"
        />
      ) : null}
      {children}
    </span>
  );
}
